function tableResize(table, name, hasRowIcon = false, minColWidth = {}, maxColWidth = {}, setResizedCount = null) {
  const storageKey = name + '.column_widths';
  const currentWidths = JSON.parse(localStorage.getItem(storageKey) || '{}');
  const resizeDivs = table.querySelectorAll('.th-resize-div');
  const colOffset = hasRowIcon ? 2 : 1;

  const resetToDefault = () => {
    localStorage.removeItem(name + '.column_widths');

    table.style.width = '100%';

    resizeDivs.forEach((div, i) => {
      const th = div.parentElement;
      th.style.minWidth = '';
      th.style.maxWidth = '';
      th.style.width = '';

      const colIndex = i + (hasRowIcon ? 2 : 1);
      const cells = table.querySelectorAll(`tbody .table-row td:nth-child(${colIndex})`);
      cells.forEach(el => {
        el.style.minWidth = '';
        el.style.maxWidth = '';
        el.style.width = '';
      });
    });

    if (setResizedCount) setResizedCount(prev => prev + 1);
  };

  let altMaxColWidth = null;
  if (Object.keys(maxColWidth).length <= 0 && table.parentElement) {
    altMaxColWidth = (table.parentElement.offsetWidth / resizeDivs.length) + 200;
  }

  const clampWidth = (field, width, headerElement, forInitial = false) => {
    let contentWidth = 0;
    headerElement.querySelectorAll('.th-span').forEach(el => contentWidth += el.offsetWidth);
    const altMinColWidth = contentWidth + 20;

    let finalWidth = width;

    if (forInitial) return finalWidth;

    // Apply Min
    if (minColWidth.hasOwnProperty(field)) {
      finalWidth = Math.max(finalWidth, minColWidth[field]);
    } else {
      finalWidth = Math.max(finalWidth, altMinColWidth);
    }

    // Apply Max
    if (maxColWidth.hasOwnProperty(field)) {
      finalWidth = Math.min(finalWidth, maxColWidth[field]);
    } else if (altMaxColWidth) {
      finalWidth = Math.min(finalWidth, altMaxColWidth);
    } else if ((!minColWidth.hasOwnProperty(field) || minColWidth[field] <= 200)) {
      if (altMinColWidth > 200) finalWidth = Math.min(finalWidth, altMinColWidth + 100);
      else if (finalWidth > 200) finalWidth = 200;
    }

    return finalWidth;
  };

  resizeDivs.forEach((div, i) => {
    if (div._resizeCleanup) {
      div._resizeCleanup();
    }

    const field = div.dataset.field;
    const th = div.parentElement;

    if (currentWidths[field]) {
      const savedWidth = currentWidths[field];
      const safeWidth = clampWidth(field, savedWidth, th, true);

      th.style.width = safeWidth + 'px';
      th.style.minWidth = safeWidth + 'px';
      th.style.maxWidth = safeWidth + 'px';

      requestAnimationFrame(() => {
        table.querySelectorAll(`tbody .table-row td:nth-child(${i + colOffset})`).forEach(td => {
          td.style.width = safeWidth + 'px';
          td.style.minWidth = safeWidth + 'px';
          td.style.maxWidth = safeWidth + 'px';
        });
      });
    }

    attachResizeListener(div, th, field, i);
  });

  if (Object.keys(currentWidths).length > 0 && setResizedCount) {
    setTimeout(() => setResizedCount(prev => prev + 1), 0);
  }

  function attachResizeListener(div, th, field, index) {
    const onMouseOver = () => div.style.borderRight = '2px solid #00336680';
    const onMouseOut = () => div.style.borderRight = '';

    const onDblClick = (e) => {
      e.preventDefault();
      resetToDefault();
    };

    const onMouseDown = (e) => {
      e.preventDefault();
      const startX = e.pageX;
      const startWidth = th.offsetWidth;
      const columnCells = table.querySelectorAll(`tbody .table-row td:nth-child(${index + colOffset})`);

      let animationFrameId;

      const onMouseMove = (moveEvent) => {
        if (animationFrameId) cancelAnimationFrame(animationFrameId);
        animationFrameId = requestAnimationFrame(() => {
          const diffX = moveEvent.pageX - startX;
          const rawWidth = startWidth + diffX;
          const newWidth = clampWidth(field, rawWidth, th);

          th.style.width = newWidth + 'px';
          th.style.minWidth = newWidth + 'px';
          th.style.maxWidth = newWidth + 'px';

          columnCells.forEach(td => {
            td.style.width = newWidth + 'px';
            td.style.minWidth = newWidth + 'px';
            td.style.maxWidth = newWidth + 'px';
          });
        });
      };

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        if (animationFrameId) cancelAnimationFrame(animationFrameId);

        const allWidths = JSON.parse(localStorage.getItem(storageKey) || '{}');
        const allResizeDivs = table.querySelectorAll('.th-resize-div');

        allResizeDivs.forEach(item => {
          const colField = item.dataset.field;
          const colTh = item.parentElement;
          allWidths[colField] = colTh.offsetWidth;
        });

        localStorage.setItem(storageKey, JSON.stringify(allWidths));
        if (setResizedCount) setResizedCount(prev => prev + 1);
      };
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    };

    div.addEventListener('mouseover', onMouseOver);
    div.addEventListener('mouseout', onMouseOut);
    div.addEventListener('dblclick', onDblClick);
    div.addEventListener('mousedown', onMouseDown);

    div._resizeCleanup = () => {
      div.removeEventListener('mouseover', onMouseOver);
      div.removeEventListener('mouseout', onMouseOut);
      div.removeEventListener('dblclick', onDblClick);
      div.removeEventListener('mousedown', onMouseDown);
      delete div._resizeCleanup;
    };
  }
}

export { tableResize };